import Persisted from 'vuex-persistedstate'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    summary: {
      rooms: [],
      customers: [],
      contracts: [],
      properties: [],
      preorders: [],
      payment_methods: [],
      usernames: [],
      roles: [],
      notes: [],
      meta: {
        room_notes_tags: [],
      },
    },
    drafts: {
      contracts: {},
    },
    computed: {
      customer_contracts: {},
    },
  },
  mutations,
  getters,
  actions,
  plugins: [
    // Persisted({ key: 'lemonapt' }),
  ],
}



// WEBPACK FOOTER //
// ./client/src/store/index.js